import axios from "axios";
import { ToastChakra } from "../helpers/toast";

import api from "../helpers/api";

const baseURL = process.env.REACT_APP_API_URL;

// Register user
const register = async (userData) => {

    const response = await axios.post(`${baseURL}/usuarios`, userData);
    if(response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
        ToastChakra('Usuario registrado', 'Bienvenido a la plataforma', 'success', 2500);
    }

    return response.data;
}

// Login user
const login = async (userData) => {
    try {
        const response = await axios.post(`${baseURL}/usuario/login`, userData);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        // Propagar el error para que sea capturado en el authSlice.js
        throw error.response ? error.response.data : new Error(error.message || 'Ocurrió un error');
    }
};


const resetPassword = async (data) => {
    const response = await api.put(`${baseURL}/usuario/reset-password/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        localStorage.removeItem("user");
        localStorage.removeItem("rol");
        localStorage.removeItem("token");
        ToastChakra('CONTRASEÑA ACTUALIZADA', 'La contraseña se ha actualizado correctamente', 'success', 2500, 'bottom-right');
    }
    return response.data;
}

// reset password
/*const resetPassword = async (data) => {
    console.log('Datos para resetear contraseña:', data);
    const response = await api.put(`${baseURL}/usuario/reset-password/${data.id}`, data);
    if(response.status === 200 || response.status === 201) {
        localStorage.removeItem("user");
        localStorage.removeItem("rol");
        localStorage.removeItem("token");
        //ToastChakra('CONTRASEÑA ACTUALIZADA', 'La contraseña se ha actualizado correctamente', 'success', 2500, 'top');
    }
    return response.data;
}*/
// Logout user
const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("rol");
    localStorage.removeItem("token");
}

const authService = {
    register,
    login,
    logout,
    resetPassword
}

export default authService;